// extracted by mini-css-extract-plugin
export default {"container":"_13LVfxhg","increasedBottom":"_2MUiecBP","nextButton":"T_Zfiwui"};